// extracted by mini-css-extract-plugin
export default {"heading":"_1ZHYIS5kVXMZezmoG4oht7","body":"_1JfIfaTl2a3O4PrAN6nOdU","closed":"_19TRXciNcNmljTDrcvKAId"};